var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"horn-top"}),_c('div',{staticClass:"horn-bottom"}),_c('div',{staticClass:"title"},[_vm._v("上架通知")]),_c('div',{staticClass:"list"},[_c('dv-scroll-board',{key:_vm.key,staticStyle:{"height":"100%"},attrs:{"config":_vm.config}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }